"use client";

import { formatCurrency } from "@/utils/helpers";
import { cn } from "@/utils/utils";

interface QuantityInputProps {
    label: string;
    value: number;
    setValue: (value: number) => void;
    price: number;
    min?: number;
    max?: number;
    icon?: React.ReactNode;
    className?: string;
}

export default function InputNumber({ label, value, setValue, price, icon, min = 0, max = 10, className }: QuantityInputProps) {
    return (
        <div className={cn(
            "flex items-center justify-between rounded-xl border-2 p-3 transition-all",
            value > 0 ? "border-amber-400 bg-amber-50" : "border-slate-200 bg-white",
            className
        )}>
            <div className="flex items-center gap-3">
                {icon && (
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-100">
                        {icon}
                    </div>
                )}
                <div>
                    <p className="font-semibold text-slate-800">{label}</p>
                    <p className="text-xs text-slate-500">je {formatCurrency(price)}</p>
                </div>
            </div>

            <div className="flex items-center gap-1 rounded-lg bg-slate-100 p-1">
                <button
                    type="button"
                    onClick={() => { if (value > min) setValue(value - 1); }}
                    className="flex h-8 w-8 items-center justify-center rounded-md text-lg font-bold text-slate-600 transition-colors hover:bg-slate-200"
                >
                    −
                </button>
                <span className="w-8 text-center font-bold text-slate-800">{value}</span>
                <button
                    type="button"
                    onClick={() => { if (value < max) setValue(value + 1); }}
                    className="flex h-8 w-8 items-center justify-center rounded-md text-lg font-bold text-slate-600 transition-colors hover:bg-slate-200"
                >
                    +
                </button>
            </div>
        </div>
    );
}
